import { makeAutoObservable, runInAction } from 'mobx';
import API from '../api/client';
import { toast } from 'react-toastify';

class ReservationStore {
  name: string = '';
  email: string = '';
  phone_number: string = '';
  party_size: number = 2;
  date: string = '';
  time: string = '';
  message: string = '';
  isSubmitting: boolean = false;
  success: boolean = false;
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setName(v: string) { this.name = v; }
  setEmail(v: string) { this.email = v; }
  setPhone(v: string) { this.phone_number = v; }
  setPartySize(v: number) { this.party_size = v; }
  setDate(v: string) { this.date = v; }
  setTime(v: string) { this.time = v; }
  setMessage(v: string) { this.message = v; }

  setFromDate(d: Date) {
    const pad = (n: number) => n.toString().padStart(2, '0');
    const yyyy = d.getFullYear();
    const mm = pad(d.getMonth() + 1);
    const dd = pad(d.getDate());
    const hh = pad(d.getHours());
    const mi = pad(d.getMinutes());
    this.date = `${yyyy}-${mm}-${dd}`;
    this.time = `${hh}:${mi}`;
  }

  get isWithin24hPT(): boolean {
    if (!this.date || !this.time) return false;
    const local = new Date(`${this.date}T${this.time}:00`);
    const now = new Date();
    const diff = local.getTime() - now.getTime();
    return diff < 24 * 60 * 60 * 1000;
  }

  async submit() {
    this.isSubmitting = true;
    this.error = null;
    this.success = false;
    try {
      if (!this.date || !this.time) {
        throw new Error('Please select a date and time.');
      }
      const reservation_datetime = new Date(`${this.date}T${this.time}:00`).toISOString();
      const resp = await API.post('/api/reservations/', {
        name: this.name,
        email: this.email,
        phone_number: this.phone_number,
        party_size: this.party_size,
        reservation_datetime,
        message: this.message,
      });
      if (resp.status === 201) {
        runInAction(() => {
          this.success = true;
          this.reset();
        });
        toast.success('Reservation request sent. We will be in touch.');
      }
    } catch (e: any) {
      const msg = e.response?.data?.error || e.message || 'Failed to send reservation.';
      runInAction(() => this.error = msg);
      toast.error(msg);
    } finally {
      runInAction(() => this.isSubmitting = false);
    }
  }

  reset() {
    this.name = '';
    this.email = '';
    this.phone_number = '';
    this.party_size = 2;
    this.date = '';
    this.time = '';
    this.message = '';
    this.isSubmitting = false;
    this.success = false;
    this.error = null;
  }
}

export default new ReservationStore();
